// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MPsz","newExpiryDate":"styles_newExpiryDate__hk1oU","footer":"styles_footer__1k896"};